module.exports = __webpack_public_path__ + "static/media/kargoe-loading-infinite-transparent.32cdc222.gif";